import { render, staticRenderFns } from "./winning-stats.vue?vue&type=template&id=049cc4c3&scoped=true"
import script from "./winning-stats.vue?vue&type=script&lang=js"
export * from "./winning-stats.vue?vue&type=script&lang=js"
import style0 from "./winning-stats.vue?vue&type=style&index=0&id=049cc4c3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cc4c3",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/winning-stats.vue
// module id = RzVA
// module chunks = 0